import { ref } from 'vue'
import { cacheStorage } from './cacheStorage'
import { loadingStorage } from '../loadingCache'

export async function useQuery<T>({
  fetcher,
  key,
  filterData,
  skipCaching,
  skipLoading
}: {
  fetcher: () => Promise<T>
  key: string
  filterData: string
  skipCaching?: boolean
  skipLoading?: boolean
}) {
  const data = ref()
  const error = ref()
  const isSuccess = ref()
  const result = {
    key,
    filterData
  }
  if (cacheStorage.hasCache(JSON.stringify(result)) && !skipCaching) {
    data.value = cacheStorage.getCache(JSON.stringify(result)).value
    return { data, error }
  }

  if (!skipLoading) {
    loadingStorage.setLoading(key)
  }
  cacheStorage.setCache(JSON.stringify(result), data)
  await fetcher()
    .then((res) => {
      data.value = res
      loadingStorage.clearSpecificLoading(key)
    })
    .catch(() => {
      loadingStorage.clearSpecificLoading(key)
      error.value = 'Error'
    })
  return { data, error, isSuccess }
}
